import React from 'react';
import Editor from "@monaco-editor/react";

export const PageEditor = (props) => {

    const defaultValue = `<State initial={{ count: 1 }}>
    {({ state, setState }) => (
        <>{state.count}</>
    )}
</State>`

    const basicSuggestion = (monaco, range) => (
        [
            {
                label: 'Antd',
                kind: monaco.languages.CompletionItemKind.Function,
                documentation: "Design library",
                insertText: '<Antd.',
                range: range
            },
            {
                label: 'COM',
                kind: monaco.languages.CompletionItemKind.Function,
                documentation: "COM Components",
                insertText: '<COM.',
                range: range
            },
            {
                label: '"express"',
                kind: monaco.languages.CompletionItemKind.Function,
                documentation: "Fast, unopinionated, minimalist web framework",
                insertText: '"express": "*"',
                range: range
            },
            {
                label: '"mkdirp"',
                kind: monaco.languages.CompletionItemKind.Function,
                documentation: "Recursively mkdir, like <code>mkdir -p</code>",
                insertText: '"mkdirp": "*"',
                range: range
            },
            {
                label: '"my-third-party-library"',
                kind: monaco.languages.CompletionItemKind.Function,
                documentation: "Describe your library here",
                insertText: '"${1:my-third-party-library}": "${2:1.2.3}"',
                insertTextRules: monaco.languages.CompletionItemInsertTextRule.InsertAsSnippet,
                range: range
            }
        ]
    )

    const subbasicSuggestion = (monaco, range) => (
        [
            {
                label: 'Test',
                kind: monaco.languages.CompletionItemKind.Function,
                documentation: "Design library",
                insertText: 'Test>',
                range: range
            }
        ]
    )

    const beforeMount = (monaco) => {        
        // monaco.languages.register({ id: 'custom' });
        // monaco.languages.setMonarchTokensProvider('custom', {
        //     tokenizer: {
        //         root: [
        //             [/Antd.*|\/Antd.*/, "custom-ok"],
        //             [/COM.*|\/COM./, "custom-ok"],
        //             [/\[info.*/, "custom-info"],
        //             [/\[[a-zA-Z 0-9:]+\]/, "custom-date"],
        //         ]
        //     }
        // });
        // monaco.editor.defineTheme('custom', {
        //     base: 'vs',
        //     inherit: false,
        //     rules: [
        //         { token: 'custom-ok', foreground: '32bba2' },
        //         { token: 'custom-error', foreground: 'ff0000', fontStyle: 'bold' },
        //         { token: 'custom-notice', foreground: 'FFA500' },
        //         { token: 'custom-date', foreground: '008800' },
        //     ]
        // });
        // monaco.languages.registerCompletionItemProvider("custom", {
        //     provideCompletionItems: function (model, position) {
        //         console.log(position)
        //         var textUntilPosition = model.getValueInRange({
        //             startLineNumber: position.lineNumber,
        //             //   startColumn: position.column -5,
        //             startColumn: 1,
        //             endLineNumber: position.lineNumber,
        //             endColumn: position.column
        //         });
        //         console.log(textUntilPosition)
        //         var match = textUntilPosition.match(
        //             /<Antd.|<COM./
        //         );
        //         console.log(match);
        //         // if (!match) {
        //         //   return [];
        //         // }
        //         var word = model.getWordUntilPosition(position);
        //         var range = {
        //             startLineNumber: position.lineNumber,
        //             endLineNumber: position.lineNumber,
        //             startColumn: word.startColumn,
        //             endColumn: word.endColumn
        //         };
        //         if (!match) {
        //             return { suggestions: basicSuggestion(monaco, range) };
        //         }
        //         return {
        //             suggestions: subbasicSuggestion(monaco, range)
        //         };
        //     }
        // });
    }

    return (
        <Editor
            height="80vh"
            options={{
                fontSize: 12
            }}
            defaultLanguage="javascript"
            beforeMount={beforeMount}
            defaultValue={defaultValue}
            {...props}
        />
    )
}